import { Injectable } from '@angular/core';
import { of } from 'rxjs/observable/of';

import { HttpInterceptorService } from '../../core/services/http-interceptor.service';
import { NavigationConfigService } from '@ispm/navigation/services/navigationConfig.service';
import { ResourceHelperService } from './resource-helper.services';

@Injectable()
export class TestListService extends ResourceHelperService {
  constructor(
    protected _http: HttpInterceptorService,
    protected _navigationConfigService: NavigationConfigService
  ) {
    super(_http, _navigationConfigService);
  }

  public getTotalEntities() { //  echo function for prevent error
    return of({ totalEntities: -1});
  }

  public getSelectedTreatment(revision: string) {
    return of({ });
  }

  public getResourceIds(query: any, page: number, sortField: string, sortOrder: string | number, hasSearchMode: any, isClubbed?: boolean, configTemplateType?: string, resourceType?: string, patientIds?: string) {
    return of({ });
  }

  getQuery(page: number, sortField: string, sortOrder: string | number, sortByType: string, sortPath: boolean, associationItems?: Array<any>, adaptableFilters?: any, resourceIds?: string) {
    return of({ });
  }

  getResource(field_list, resources_ids, associationItems?: Array<any>, adaptableFilters?: any, additionalParams?: any) {
    return of({ });
  }

  getResourceIdsPatientTests(patientId: string, orgId: string) {
    return of({ });
  }

  getTreatments(patientId: string, revision: string) {
    return of({ });
  }
}

